import './style.scss';
import React, { Component } from 'react';
import { MODAL_CARD_FORM, MODAL_CARD_FORM_TRASHED, showModal } from '../../../../../../modules/modals';
import { connect } from 'react-redux';
import { deleteCard } from '../../../../actions';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

export class Item extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      modal: false,
    }
  }
  render() {
    const {formatMessage} = this.context;
    const {item, showModal, deleteCard} = this.props;
    console.log("🚀 ~ file: Item.jsx ~ line 21 ~ Item ~ render ~ item", item)
    const { modal } = this.state;
  
    return <div className='ItemCard'>
      <Modal
        isOpen = {modal}
        style = {{
            overlay : {zIndex: 9999999},
        }}
        onRequestClose={() => {}}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content"
      >
        <div className="create-dialog-modal-content__header">
          <div className="create-dialog-modal-content__title">{formatMessage('msgTextCloseCardModalDeleteTrashed')}</div>
        </div>
        <div className="create-dialog-modal-content__body">
          <div className="create-dialog-form form-quiz-create">
            <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextCardModalDelete')}</div>
            <div className="create-dialog-form__group flex">
              <button className="btn btn-primary" type="button" onClick={() => {
                this.setState({modal: false})
                deleteCard(item.id)
              }}>{formatMessage('Yes')}</button>
              <button className="btn btn-warning" type="button" onClick={() => this.setState({modal: false})}>{formatMessage('No')}</button>
            </div>
          </div>
          
        </div>
      </Modal>
      <div className='actions'>
        <div className='icon' onClick={() => {
          showModal({
            modalType : MODAL_CARD_FORM_TRASHED,
            modalProps : {
              initialValues: {...item, category_id: '', subject_id: ''}
            }
          });
        }}>
          <img src="/build/images/uxwing-svg-icon-editor.svg" title={formatMessage('Recover')} width="48" height="48"/>
        </div>
        <div className='icon' onClick={() => {this.setState({modal: true})}}>
          <img src="/build/images/GarbageButton.svg?dd496e1175bddf2473114d4037e004a8" width="48" height="48"/>
        </div>
      </div>
      <div className='question'>
        {item.question_img && <div className='image'><img src={item.question_img} /></div>}
        <div className='text'>
          <div style={{width: '100%'}} dangerouslySetInnerHTML={{__html: item.question}}/>
        </div>
      </div>
      <hr/>
      <div className='question'>
        {item.answer_img && <div className='image'><img src={item.answer_img} /></div>}
        <div className='text'>
          <div style={{width: '100%'}} dangerouslySetInnerHTML={{__html: item.answer}}/>
        </div>
      </div>
    </div>;
  }
}

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  showModal,
  deleteCard,
}

export default connect(mapStateToProps, mapDispatchToProps)(Item);




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardTrashed/components/Cards/components/Item/Item.jsx